import { inject } from '@angular/core';
import { RedirectFunction, Router } from '@angular/router';
import { SessionFacade } from '@app/store/session';
import { filter, map } from 'rxjs';

export const initialize = (): RedirectFunction => {
    return () => {
        const router = inject(Router);
        const sessionFacade = inject(SessionFacade);

        sessionFacade.clear();
        sessionFacade.getSession();

        return sessionFacade.loaded$.pipe(
            filter((loaded) => loaded !== null),
            map((loaded) => {
                return loaded === true ? router.createUrlTree(['/', 'dashboard']) : router.createUrlTree(['/', 'auth']);
            }),
        );
    };
};
